import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class QrcodeComponent {

}
